import * as React from 'react';

import i18n from 'helper/i18n';

import IconNumber, { IconNumberTypes } from 'components/atoms/IconNumber';
import InfoSummary from 'components/atoms/InfoSummary';
import InfoText from 'components/atoms/InfoText';
import ProgressLine from 'components/atoms/ProgressLine';
import ProgressRadial from 'components/atoms/ProgressRadial';
import Bevel from 'components/helper/Bevel';
import BoardFeedback from 'components/molecules/Board/BoardFeedback';
import Tiles, { Cell, Tile } from 'components/molecules/Tiles';
import { CoachIsEnumType } from '../../CoachSelector/CoachSelector';

type ActivityDto = {
	type: IconNumberTypes;
	count: number;
};

export type BoardStatsProps = {
	calories?: number;
	todos: {
		done: number;
		total: number;
		percentage: number;
	};
	activities: ActivityDto[];
	days: {
		done: number;
		total: number;
		percentage: number;
	};
	motivation?: 'PERFECT' | 'GOOD_WORK' | 'GET_STARTED';
	coach: CoachIsEnumType;
};

const UICellModifiers = {
	borderless: ['m-tiles__cell--borderless'],
};

export const BoardStats = ({ calories, todos, days, activities, motivation, coach }: BoardStatsProps) => (
	<div className="m-board-stats">
		<div className="container container--full-width-ms">
			<div className="row">
				<div className="col-xs-12">
					<h2 className="m-board-stats__title">{i18n('react.impulsCoach.molecules.BoardStats.title')}</h2>
					<Tiles>
						<Tile line>
							<Cell
								label={
									calories ? i18n('react.impulsCoach.molecules.BoardStats.calories.label') : void 0
								}
							>
								{calories ? (
									<InfoSummary
										title={`${Math.floor(calories)}`}
										icon="workout"
										text={i18n('react.impulsCoach.molecules.BoardStats.calories.unit')}
									/>
								) : (
									<InfoText text={i18n('react.impulsCoach.molecules.BoardStats.calories.empty')} />
								)}
							</Cell>
							<Cell label={i18n('react.impulsCoach.molecules.BoardStats.todos.label')}>
								{todos !== null && (
									<ProgressRadial
										reach={todos.done}
										total={todos.total}
										text={i18n('react.impulsCoach.molecules.BoardStats.todos.text')}
										meterColor="0099A6"
										percent={todos.percentage}
									/>
								)}
							</Cell>
						</Tile>
						<Tile>
							<Cell label={i18n('react.impulsCoach.molecules.BoardStats.activities.label')}>
								<div className="m-board-completed">
									{activities.map(({ count, type }) => (
										<div key={`${type}-${count}`} className="m-board-completed__type">
											<IconNumber
												type={type}
												count={count}
												label={i18n(
													`react.impulsCoach.molecules.BoardStats.activities.${type}.label`
												)}
												modifier="vertical"
											/>
										</div>
									))}
								</div>
							</Cell>
							<Cell
								label={i18n('react.impulsCoach.molecules.BoardStats.days.label')}
								modifiers={UICellModifiers.borderless}
							>
								{days && (
									<ProgressLine
										reach={days.done}
										total={days.total}
										percent={days.percentage}
										text={i18n('react.impulsCoach.molecules.BoardStats.days.unit')}
									/>
								)}
							</Cell>
						</Tile>
					</Tiles>
				</div>
			</div>
			<div className="row">
				<div className="col-xs-12">
					<BoardFeedback coach={coach} level={motivation as any} />
				</div>
			</div>
		</div>
		<Bevel modifier="bottom-right" color="0099A6" />
	</div>
);

export default BoardStats;
